import m from 'mithril';

let titleMC = {
  view: function(vnode) {
    return(m("b", {}, "Breathe"));
  }
};

var legendMC = {
  view: function(vnode) {
    return(m("div", {}, "Follow the circle and match your breathing with it. Click the circle to enable wake lock."));
  }
};

let buildRefMC = {
  view: function(vnode) {
    return(m("div", {}, `Build: ${BUILD_REF}`));
  }
};

let buildTSMC = {
  view: function(vnode) {
    return(m("div", {}, `Build: ${BUILD_TIMESTAMP}`));
  }
};

let preambleMC = {
  oncreate: function(vnode) {
    // placeholder for wake lock api setup
    return(true);
	},
  view: function(vnode) {
    let result = m("div",
                   {class: "header"},
                   [
                    titleMC,
                    legendMC,
                    buildRefMC,
                    buildTSMC,
                  ].map(x => m(x, vnode.attrs)));
    return(result);
  }
}

export { preambleMC };